import Counter from "../Counter/Counter"

type PrimaryLabelPropsType = { 
  title : string | { value? : number, unit? : JSX.Element | string }, 
  subtitle : string | { value? : number, unit? : JSX.Element | string },
  type : "one" | "two" | string, 
  revirsed : boolean
}

const PrimaryLabel = ({ title, subtitle, type = "one", revirsed } : PrimaryLabelPropsType) => {
  return (
    <div className={`primary-label ${type}`}>
        {
        type === "one" ?
        revirsed ?
        <>
        <h3 className="title">{typeof title === "string" ? title : <>{title.value ? <Counter counterValue={title.value} applyCounteClassName="title" /> : ""}{title.unit}</>}</h3>
        <h4 className="subtitle">{typeof subtitle === "string" ? subtitle : <>{subtitle.value ? <Counter counterValue={subtitle.value} applyCounteClassName="title" /> : ""}{subtitle.unit}</>}</h4>
        </> :
        <>
        <h3 className="subtitle">{typeof title === "string" ? title : <>{title.value ? <Counter counterValue={title.value} applyCounteClassName="title" /> : "" }{title.unit}</>}</h3>
        <h4 className="title">{typeof subtitle === "string" ? subtitle : <>{subtitle.value ? <Counter counterValue={subtitle.value} applyCounteClassName="title" /> : "" }{subtitle.unit}</>}</h4>
        </>
        : 
        <>
          <h4 className="title">{typeof subtitle === "string" ? subtitle : <>{subtitle.value ? <Counter counterValue={subtitle.value} applyCounteClassName="title" /> : "" }{subtitle.unit}</>}</h4>
          <h3 className="subtitle">{typeof title === "string" ? title : <>{title.value ? <Counter counterValue={title.value} applyCounteClassName="title" /> : "" }{title.unit}</>}</h3>
        </>
        }
    </div>
  )
}

export default PrimaryLabel